export const DEPOSIT_VALUE_APPEAL_INTERLOCUTORY = 14411.57
export const DEPOSIT_VALUE_APPEAL_EMBARGOES = 28823.14

export const KEYS_STORAGE_MULTICALCULO = {
  selectedQuotation: 'multicalculo-selected-quotation',
  selectedProduct: 'multicalculo-selected-product-quotation',
  selectedModality: 'multicalculo-selected-modality',
  selectedSector: 'multicalculo-selected-sector',
  step1Form: 'multicalculo-judicial-appeal-step1-form',
  identifier: 'multicalculo-identifier',
}

export const DOCUMENT_TYPE = {
  DRAFT: 'Draft',
  BILLET: 'Billet',
  POLICY: 'Policy',
}

export const RECEIVED = 'Cotacao Recebida'
export const SENT = 'Cotacao Enviada'
export const DENIED = 'Nova Solicitação'
export const PENDING_PROPOSAL_ACCEPTANCE = 'Aguardando Aceite Proposta'
export const PENDING_ISSUANCE = 'Aguardando Emissao'
export const ISSUED = 'Apolice Emitida'
export const ERROR = 'Erro Na Emissao'

export const OPTIONS_MULTICALCULO_STATUS_FILTER = [
  RECEIVED,
  SENT,
  DENIED,
  PENDING_ISSUANCE,
  PENDING_PROPOSAL_ACCEPTANCE,
  ISSUED,
  ERROR,
]

export const SOLICITATION_STATUS_EM_ANALISE = 'Em Análise'
export const SOLICITATION_STATUS_EMITIR_APOLICE = 'Emitir Apólice'
export const SOLICITATION_STATUS_AGUARDANDO_EMISSAO = 'Aguardando Emissão'
export const SOLICITATION_STATUS_EMITIDA = 'Emitida'
export const SOLICITATION_STATUS_RECUSADA = 'Recusada'
export const SOLICITATION_STATUS_AQUARDANDO_ANALISE = 'Área Técnica - Em Análise'

export const OPTIONS_SOLICITATION_STATUS_FILTER = [
  SOLICITATION_STATUS_EM_ANALISE,
  SOLICITATION_STATUS_EMITIR_APOLICE,
  SOLICITATION_STATUS_AQUARDANDO_ANALISE,
  SOLICITATION_STATUS_AGUARDANDO_EMISSAO,
  SOLICITATION_STATUS_EMITIDA,
  SOLICITATION_STATUS_RECUSADA,
]
